import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCartItems = localStorage.getItem("teingshomeCartItems");
      return savedCartItems ? JSON.parse(savedCartItems) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("teingshomeCartItems", JSON.stringify(cartItems));
    } catch {}
  }, [cartItems]);

  const addToCart = (productId, quantity, size, color) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find(
        (item) =>
          item.id === productId && item.size === size && item.color === color
      );

      if (existingItem) {
        return prevItems.map((item) =>
          item.id === productId && item.size === size && item.color === color
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        const newItem = { id: productId, size, color, quantity };
        return [...prevItems, newItem];
      }
    });
  };

  const removeFromCart = (productId, size, color) => {
    setCartItems((prevItems) =>
      prevItems.filter(
        (item) =>
          !(item.id === productId && item.size === size && item.color === color)
      )
    );
  };

  const updateQuantity = (productId, size, color, quantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId && item.size === size && item.color === color
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem("teingshomeWishlist") || "[]"); }
    catch { return []; }
  });

  useEffect(() => { localStorage.setItem("teingshomeWishlist", JSON.stringify(wishlist)); }, [wishlist]);
  const addWishlist = (productId) => setWishlist((items) => items.includes(productId) ? items : [...items, productId]);
  const removeWishlist = (productId) => setWishlist((items) => items.filter((id) => id !== productId));
  const toggleWishlist = (productId) => wishlist.includes(productId) ? removeWishlist(productId) : addWishlist(productId);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        updateQuantity,
        wishlist,
        addWishlist,
        removeWishlist,
        toggleWishlist,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
